module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-page-layout', {
    attrs: {
      "config": _vm.pageConfig
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.IsLoading),
      expression: "IsLoading"
    }],
    attrs: {
      "element-loading-text": "加载中",
      "data": [_vm.DataForm]
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "采购询价单",
      "prop": "Code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系人",
      "prop": "ContactName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系人电话：",
      "prop": "ContactPhone"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "联系人邮箱：",
      "prop": "ContactEmail"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户订单号",
      "prop": "ReferenceCode"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注：",
      "prop": "Notes"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm._f("nullShow")(props.row.Notes)))]
      }
    }])
  })], 1), _vm._v(" "), _c('h3', {
    staticStyle: {
      "line-height": "3em"
    }
  }, [_vm._v("物料清单")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.IsLoading),
      expression: "IsLoading"
    }],
    attrs: {
      "element-loading-text": "加载中",
      "data": _vm.DataForm.Lines
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "物料名称",
      "width": "260px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-col', [_vm._v(_vm._s(props.row.Product != null ? props.row.Product.Name : props.row.ProductName))]), _vm._v(" "), _c('el-col', [_vm._v("物料编码:" + _vm._s(props.row.Product != null ? props.row.Product.Code : props.row.ProductCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品项"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm._f("ConditionColor")(props.row.Condition.Name)
          }
        }, [_vm._v(_vm._s(props.row.Condition.Name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "品牌"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('p', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(props.row.Product != null ? props.row.Product.Brand.Name : props.row.BrandName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "机型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('p', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(props.row.Product != null ? props.row.Product.Model.Name : props.row.ModelName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "模块"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('p', {
          attrs: {
            "type": "primary"
          }
        }, [_vm._v(_vm._s(props.row.Product != null ? props.row.Product.Module.Name : props.row.ModuleName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量",
      "prop": "Quantity"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f90a096"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Order/PurchaseDetail_order.vue
// module id = 741
// module chunks = 0